import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  .fileUploaderLabel {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n  .ant-upload-list {\n    display: flex;\n  }\n  .uploadDescription {\n    color: rgba(27, 27, 41, 0.7);\n  }\n\n  .imgUploadAlert {\n    width: 100%;\n    font-size: 12px;\n    line-height: 1.5;\n    color: ",
        ";\n    padding-top: 8px;\n    margin: 0 8px 24px;\n    border-top: 1px solid ",
        ";\n  }\n\n  .ant-upload-wrapper {\n    div.ant-upload {\n      .ant-upload {\n        .fileUploaderLabel {\n          .ant-btn {\n            font-size: 12px;\n            font-weight: bold;\n            color: #1890ff;\n            height: auto;\n            border: 0;\n            padding: 0 0 0 6px;\n            margin-top: -8px;\n\n            .anticon {\n              & + span {\n                font-size: 12px;\n                font-weight: bold;\n                color: #1890ff;\n                margin-left: 2px;\n              }\n            }\n          }\n\n          .uploadDescription {\n            font-size: 12px;\n            color: rgba(27, 27, 41, 0.7);\n            padding-top: 4px;\n          }\n        }\n      }\n    }\n\n    .ant-upload-list {\n    }\n  }\n\n  .uploadFileBox {\n    margin-bottom: 15px;\n  }\n\n  .ant-upload.ant-upload-select {\n    width: 100%;\n  }\n\n  .ant-upload-list {\n    background-color: rgba(27, 27, 41, 0.03);\n    padding: 10px;\n    min-height: 100px;\n  }\n\n  @media (max-width: 1200px) {\n  }\n  @media (max-width: 768px) {\n    .ant-col-3,\n    .ant-col-5,\n    .ant-col-7 {\n      flex: 0 0 50%;\n      max-width: 50%;\n    }\n    .ant-col-12 {\n      flex: 0 0 100%;\n      max-width: 100%;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  margin-bottom: 24px;\n\n  .ant-row {\n    .ant-col {\n      label {\n        font-size: 14px;\n        font-weight: 600;\n        color: ",
        ";\n      }\n\n      .ant-form-item-control-input {\n        .ant-form-item-control-input-content {\n          .ant-select .ant-select-selector,\n          .ant-input-affix-wrapper,\n          .ant-input,\n          .ant-picker {\n            border-radius: 2px;\n            border-color: #dbdbdb;\n          }\n        }\n      }\n\n      .ant-picker {\n        width: 100%;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  margin-bottom: 8px;\n  font-weight: bold;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n          background: rgba(27, 27, 41, 0.3) !important;\n\n          &:hover {\n            background: rgba(0, 47, 168, 0.9) !important;\n          }\n        "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n          background: #002fa8 !important;\n        "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  display: block;\n  width: 100%;\n  padding: 0;\n  border-radius: 2px;\n  ",
        ";\n  &,\n  &:disabled {\n    background-color: #002fa8;\n  }\n\n  &:not(:disabled):hover {\n    background-color: #113ac3;\n  }\n\n  span {\n    display: block;\n    height: 100%;\n    font-size: 16px;\n    font-weight: bold;\n    color: #fff;\n    line-height: 46px;\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getError } from "@/components/Formik";
import { Col, Row } from "@/lib/web-ui";
import { PlusOutlined } from "@ant-design/icons";
import { themeGet } from "@styled-system/theme-get";
import { Button, DatePicker, Upload } from "antd";
import { Formik } from "formik";
import { Form, FormItem, Input, Select, SubmitButton } from "formik-antd";
import React, { useState } from "react";
import styled, { css } from "styled-components";
import * as Yup from "yup";
import { suffix } from "@/components/Suffix";
const TextArea = Input.TextArea;
const { Dragger  } = Upload;
export const ProtectionReportFormSchema = Yup.object().shape({
    type: Yup.string().required("선택해주세요"),
    publisher: Yup.string().required("선택해주세요"),
    title: Yup.string().required("최소 1글자 이상 입력 필요"),
    link: Yup.string().required("최소 1글자 이상 입력 필요"),
    name: Yup.string().required("최소 1글자 이상 입력 필요"),
    channel: Yup.string().required("선택해주세요"),
    profit: Yup.string().required("선택해주세요"),
    content: Yup.string().required("설명은 반드시 입력이 필요합니다.").max(1000, "최대 1,000자 이내(공백포함)로 작성해주세요")
});
const ProtectionReportFormWrapper = styled.div.withConfig({
    componentId: "sc-49bf2a93-0"
})(_templateObject(), themeGet("text.0", "#1B1B29"), themeGet("border.1", "#E8E8EA"));
const StyledFormItem = styled(FormItem).withConfig({
    componentId: "sc-49bf2a93-1"
})(_templateObject1(), themeGet("text.0", "#1B1B29"));
const FieldTitle = styled.p.withConfig({
    componentId: "sc-49bf2a93-2"
})(_templateObject2());
const StyledSubmitButton = styled(SubmitButton).withConfig({
    componentId: "sc-49bf2a93-3"
})(_templateObject5(), (props)=>props.disabled ? css(_templateObject3()) : css(_templateObject4()));
const getBase64 = (img, callback)=>{
    const reader = new FileReader();
    reader.addEventListener("load", ()=>callback(reader.result));
    reader.readAsDataURL(img);
};
export const ProtectionReportForm = (param)=>{
    let { name , onSubmit , forwardRef , initialStatus , initialValues , publisherOptions , onSetImageFile , onSetPdfFile  } = param;
    // /*업로드 로직*/
    const [loading, setLoading] = useState(false);
    // const [imageUrl, setImageUrl] = useState<string>()
    const imgUploadChange = (info)=>{
        if (info.file.status === "uploading") {
            setLoading(true);
            return;
        }
        if (info.file.status === "done") {
            // Get this url from response in real world.
            getBase64(info.file.originFileObj, (url)=>{
                setLoading(false);
            // setImageUrl(url)
            });
        }
    };
    const pdfUploadChange = (info)=>{
        if (info.file.status === "uploading") {
            setLoading(true);
            return;
        }
        if (info.file.status === "done") {
            // Get this url from response in real world.
            getBase64(info.file.originFileObj, (url)=>{
                setLoading(false);
            // setImageUrl(url)
            });
        }
    };
    return /*#__PURE__*/ _jsx(ProtectionReportFormWrapper, {
        children: /*#__PURE__*/ _jsx(Formik, {
            innerRef: (instance)=>{
                if (forwardRef) {
                    forwardRef.current = instance;
                }
            },
            validationSchema: ProtectionReportFormSchema,
            onSubmit: onSubmit,
            initialValues: initialValues,
            initialStatus: initialStatus,
            children: (param)=>{
                let { handleChange , handleBlur , touched , errors , isValid , handleSubmit , setValues , values , isSubmitting , status  } = param;
                // const emailError = getError('email', { touched, errors, status })
                const contentError = getError("content", {
                    touched,
                    errors,
                    status
                });
                const typeError = getError("type", {
                    touched,
                    errors,
                    status
                });
                const publisherError = getError("publisher", {
                    touched,
                    errors,
                    status
                });
                const titleError = getError("title", {
                    touched,
                    errors,
                    status
                });
                const linkError = getError("link", {
                    touched,
                    errors,
                    status
                });
                const nameError = getError("name", {
                    touched,
                    errors,
                    status
                });
                const onDateChange = (date, dateString)=>{
                    values.start_date = new Date(dateString);
                };
                const fileNullCheck = values.fileImage.length !== 0 && values.fileData.length !== 0;
                return /*#__PURE__*/ _jsxs(Form, {
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ _jsxs(Row, {
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    span: 3,
                                    children: /*#__PURE__*/ _jsx(StyledFormItem, {
                                        name: "type",
                                        label: "구분",
                                        children: /*#__PURE__*/ _jsx(Select, {
                                            placeholder: "선택",
                                            onChange: handleChange("type"),
                                            autoFocus: true,
                                            onBlur: handleBlur("type"),
                                            name: "type",
                                            options: [
                                                {
                                                    value: "normal",
                                                    label: "일반"
                                                },
                                                {
                                                    value: "enterprise",
                                                    label: "기업"
                                                }
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    span: 3,
                                    children: /*#__PURE__*/ _jsx(StyledFormItem, {
                                        name: "profit",
                                        label: "영리여부",
                                        children: /*#__PURE__*/ _jsx(Select, {
                                            onChange: handleChange("profit"),
                                            defaultValue: "비영리",
                                            name: "profit",
                                            options: [
                                                {
                                                    value: "영리",
                                                    label: "영리"
                                                },
                                                {
                                                    value: "비영리",
                                                    label: "비영리"
                                                }
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    span: 3,
                                    children: /*#__PURE__*/ _jsx(StyledFormItem, {
                                        name: "channel",
                                        label: "침해채널",
                                        children: /*#__PURE__*/ _jsx(Select, {
                                            onChange: handleChange("channel"),
                                            placeholder: "선택",
                                            name: "channel",
                                            options: [
                                                {
                                                    value: "유튜브",
                                                    label: "유튜브"
                                                },
                                                {
                                                    value: "블로그",
                                                    label: "블로그"
                                                },
                                                {
                                                    value: "카페",
                                                    label: "카페"
                                                },
                                                {
                                                    value: "개인사이트",
                                                    label: "개인사이트"
                                                },
                                                {
                                                    value: "어플리케이션",
                                                    label: "어플리케이션"
                                                },
                                                {
                                                    value: "기타",
                                                    label: "기타"
                                                }
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    span: 3,
                                    children: /*#__PURE__*/ _jsx(StyledFormItem, {
                                        name: "publisher",
                                        label: "출판사",
                                        children: /*#__PURE__*/ _jsx(Select, {
                                            onChange: handleChange("publisher"),
                                            placeholder: "선택",
                                            name: "publisher",
                                            options: publisherOptions
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    span: 12,
                                    children: /*#__PURE__*/ _jsx(StyledFormItem, {
                                        name: "title",
                                        label: "교재명",
                                        children: /*#__PURE__*/ _jsx(Input, {
                                            name: "title",
                                            placeholder: "교재명을 입력하세요",
                                            suffix: suffix
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Row, {
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    span: 12,
                                    children: /*#__PURE__*/ _jsx(StyledFormItem, {
                                        hasFeedback: false,
                                        name: "link",
                                        label: "게시물 링크",
                                        children: /*#__PURE__*/ _jsx(Input, {
                                            name: "link",
                                            placeholder: "www.link.com",
                                            suffix: suffix
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    span: 7,
                                    children: /*#__PURE__*/ _jsx(StyledFormItem, {
                                        hasFeedback: false,
                                        name: "name",
                                        label: "침해자명",
                                        children: /*#__PURE__*/ _jsx(Input, {
                                            name: "name",
                                            placeholder: "입력하세요",
                                            suffix: suffix
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    span: 5,
                                    children: /*#__PURE__*/ _jsx(StyledFormItem, {
                                        name: "startDate",
                                        label: "침해시작일(선택)",
                                        children: /*#__PURE__*/ _jsx(DatePicker, {
                                            placeholder: "날짜를 선택하세요",
                                            onChange: onDateChange,
                                            name: "startDate"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Row, {
                            gutter: 16,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "imgUploadAlert",
                                    children: "* 침해 이미지 , 침해 자료 중 1개 이상 등록해 주세요."
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    span: 12,
                                    children: /*#__PURE__*/ _jsx(Upload, {
                                        // listType="picture-card"
                                        maxCount: 5,
                                        multiple: true,
                                        // fileList={fileList}
                                        beforeUpload: (info)=>{
                                            onSetImageFile([
                                                info
                                            ]);
                                            return false;
                                        },
                                        accept: ".jpg, .jpeg, .png",
                                        onChange: imgUploadChange,
                                        style: {
                                            width: "100%",
                                            marginTop: "25px"
                                        },
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "fileUploaderLabel",
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    style: {
                                                        display: "flex"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx(FieldTitle, {
                                                            children: "침해 이미지"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Button, {
                                                            icon: /*#__PURE__*/ _jsx(PlusOutlined, {}),
                                                            children: "등록하기"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "uploadDescription",
                                                    children: "*최대 10장까지 첨부 가능"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(Col, {
                                    span: 12,
                                    children: [
                                        /*#__PURE__*/ _jsx(Upload, {
                                            name: "data",
                                            // listType="picture-card"
                                            maxCount: 10,
                                            accept: ".pdf",
                                            beforeUpload: (info)=>{
                                                onSetPdfFile([
                                                    info
                                                ]);
                                                return false;
                                            },
                                            onChange: pdfUploadChange,
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "fileUploaderLabel",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        style: {
                                                            display: "flex"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ _jsx(FieldTitle, {
                                                                children: "침해 자료"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Button, {
                                                                icon: /*#__PURE__*/ _jsx(PlusOutlined, {}),
                                                                children: "등록하기"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "uploadDescription",
                                                        children: "*최대 5개까지 첨부 가능"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "uploadFileBox"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Row, {
                            children: /*#__PURE__*/ _jsx(Col, {
                                span: 24,
                                children: /*#__PURE__*/ _jsx(StyledFormItem, {
                                    name: "content",
                                    label: "침해 상세 내용",
                                    children: /*#__PURE__*/ _jsx(TextArea, {
                                        style: {
                                            width: "100%",
                                            minHeight: 100
                                        },
                                        name: "content",
                                        placeholder: "최대 1,000자 이내(공백포함)로 작성해주세요."
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(Row, {
                            children: /*#__PURE__*/ _jsx(Col, {
                                span: 24,
                                children: /*#__PURE__*/ _jsx(StyledSubmitButton, {
                                    disabled: values.title === "" || values.publisher === "" || values.name === "" || values.content === "" || values.link === "" || values.profit === null || values.channel === null || fileNullCheck,
                                    onSubmit: handleSubmit,
                                    loading: isSubmitting,
                                    style: {
                                        width: "100%",
                                        height: 48
                                    },
                                    children: "신고"
                                })
                            })
                        })
                    ]
                });
            }
        })
    });
};
